import axiosInstance from "./baseUrl";

export const fetchAllNotificationsService = (params: any) =>
  axiosInstance.get("/v1/notifications", { params });

export const sendSingleNotificationService = (data: any) =>
  axiosInstance.post("/v1/notifications/send-push", data);

export const sendBulkNotificationService = (data: any) =>
  axiosInstance.post("/v1/notifications/send-bulk-push", data);

// WhatsApp Notification Services
export const sendWhatsAppSingleNotificationService = (data: any) =>
  axiosInstance.post("/v1/termi/send-template", data);

export const sendWhatsAppBulkNotificationService = (data: any) =>
  axiosInstance.post("/v1/termi/send-template-bulk", data);

// Promo Notification Service (for anonymous installs)
export const sendPromoNotificationService = (data: any) =>
  axiosInstance.post("/v1/notifications/anonymous/send-promo", data, {
    timeout: 60000, // 60s - this endpoint can be slow when targeting all anonymous installs
  });
